import DotsLoading from 'components/loadings/dotsLoading'
import React, { useCallback, useRef } from 'react'

interface InfinitScrollProps {
    children: React.ReactNode
    isloading?: boolean
    onWatchEnd: () => void
}
const InfinitScroll = ({
    children,
    isloading,
    onWatchEnd,
}: InfinitScrollProps) => {
    const observer = useRef<IntersectionObserver | null>(null)

    const lastElementChat = useCallback(
        (node: HTMLDivElement) => {
            if (observer.current) observer.current.disconnect()
            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    onWatchEnd()
                }
            })
            if (node) observer.current.observe(node)
        },
        [onWatchEnd]
    )
    return (
        <>
            {isloading ? <DotsLoading /> : children}
            <div ref={lastElementChat} />
        </>
    )
}

export default InfinitScroll
